module.exports = __webpack_public_path__ + "img/time-progress-icon.eb694f70.svg";